export const MetricWidgetBase = `
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  margin: 2.5px;
  padding: 5px 10px;
  box-sizing: border-box;
  flex-grow: 1;`;

export const green = '#00A150' ;

export const red = 'red';
